/*jshint esversion: 11 */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert
} from 'reactstrap';
import Select from 'react-select';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import PageDataLoader from '../Utility/PageDataLoader';
import moment from 'moment';
import { attendanceStatus, attendanceType } from '../Utility/Enumerator';
import { updateAttendance } from '../../api/attendance';

const UpdateAttendanceModal = ({
  modalOpenState,
  closeModalHandler,
  authUser,
  fetchNewAttendanceList,
  attendanceInfoLoading,
  attendanceInfo,
  setLeaveBalance
}) => {
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [attendanceUpdateRequestLoading, setAttendanceUpdateRequestLoading] =
    useState(false);
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });

  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedType, setSelectedType] = useState(null);

  async function handleAttendanceUpdate(event, values) {
  resetErrorAlert();
  setAttendanceUpdateRequestLoading(true);

  if (!selectedStatus) {
    showErrorAlert('Please select status');
    setAttendanceUpdateRequestLoading(false);
    return;
  }

  if (!selectedType) {
    showErrorAlert('Please select type');
    setAttendanceUpdateRequestLoading(false);
    return;
  }

  const { response, error } = await updateAttendance(
    attendanceInfo._id,
    authUser._id,
    selectedStatus.value,
    selectedType.value,
    values.remarks,
    values.reason,
    values.start_date,
    values.end_date
  );

  setAttendanceUpdateRequestLoading(false);

  if (error) {
    showErrorAlert(error);
    return;
  }

  const oldDays =
    Math.floor(
      (new Date(attendanceInfo.end_date) -
        new Date(attendanceInfo.start_date)) /
        (1000 * 60 * 60 * 24)
    ) + 1;

  const newDays =
    Math.floor(
      (new Date(values.end_date) -
        new Date(values.start_date)) /
        (1000 * 60 * 60 * 24)
    ) + 1;

  setLeaveBalance((prev) => {
    const updated = { ...prev };

    if (attendanceInfo.type === 'Paid Leave') {
      updated.paid.requested -= oldDays;
      updated.paid.available += oldDays;
    }

    if (attendanceInfo.type === 'Saturday Leave') {
      updated.saturday.requested -= 1;
      updated.saturday.available += 1;
    }

    if (attendanceInfo.type === 'Unpaid Leave') {
      updated.unpaid.requested -= oldDays;
    }

    if (selectedType.value === 'Paid Leave') {
      updated.paid.requested += newDays;
      updated.paid.available -= newDays;
    }

    if (selectedType.value === 'Saturday Leave') {
      updated.saturday.requested += 1;
      updated.saturday.available -= 1;
    }

    if (selectedType.value === 'Unpaid Leave') {
      updated.unpaid.requested += newDays;
    }

    return { ...updated };
  });

  closeModalHandler();
  showSuccessAlert(response.message);
  await fetchNewAttendanceList();
}

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  function resetState() {
    resetSuccessAlert();
    resetErrorAlert();
  }

  const handleStatusSelection = (selectedItem) => {
    setSelectedStatus(selectedItem);
  };

  const handleTypeSelection = (selectedItem) => {
    setSelectedType(selectedItem);
  };

  useEffect(() => {
    if (authUser) {
      setStatusOptions(buildListOptions(attendanceStatus));
      setTypeOptions(buildListOptions(attendanceType));
    }
    // eslint-disable-next-line
  }, [authUser, modalOpenState]);

  useEffect(() => {
    if (attendanceInfo && statusOptions.length > 0) {
      setSelectedStatus(
        statusOptions.find((k) => k.value === attendanceInfo?.status)
      );
      setSelectedType(
        typeOptions.find((k) => k.value === attendanceInfo?.type)
      );
    }
  }, [attendanceInfo, statusOptions, typeOptions]);

  function buildListOptions(list) {
    return list.map((item) => ({
      value: item,
      label: item
    }));
  }

  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert success title="Updated" onConfirm={resetState}>
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="xl">
        <ModalHeader toggle={closeModalHandler}>
          {attendanceInfoLoading
            ? 'Loading ...'
            : 'Edit [' + attendanceInfo.leave_reason + ']'}
        </ModalHeader>
        <ModalBody>
          {attendanceInfoLoading ? (
            <div className="d-flex justify-content-center">
              <PageDataLoader />
            </div>
          ) : (
            <React.Fragment>
              {requestError ? (
                <Alert
                  color="danger"
                  role="alert"
                  isOpen={requestError.show_alert}
                  toggle={resetErrorAlert}
                >
                  <i className="mdi mdi-block-helper mr-2"></i>
                  {requestError.message}
                </Alert>
              ) : null}
              <AvForm
                className="needs-validation"
                onValidSubmit={handleAttendanceUpdate}
              >
                <Row>
                  <Col md="12">
                    <FormGroup>
                      <Label>Reason</Label>
                      <AvField
                        name="reason"
                        placeholder="Enter Reason ..."
                        type="text"
                        className="form-control"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: 'Reason is required'
                          }
                        }}
                        defaultValue={attendanceInfo?.leave_reason}
                        readOnly={authUser?.user_type === 'super_admin'}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>Start Date</Label>
                      <AvField
                        name="start_date"
                        placeholder="Enter Start Date ..."
                        type="date"
                        className="form-control"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: 'Start date is required'
                          }
                        }}
                        defaultValue={
                          attendanceInfo &&
                          moment(new Date(attendanceInfo.start_date)).format(
                            'YYYY-MM-DD'
                          )
                        }
                        readOnly={authUser?.user_type === 'super_admin'}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>End Date</Label>
                      <AvField
                        name="end_date"
                        placeholder="Enter End Date ..."
                        type="date"
                        className="form-control"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: 'End date is required'
                          }
                        }}
                        defaultValue={
                          attendanceInfo &&
                          moment(new Date(attendanceInfo.end_date)).format(
                            'YYYY-MM-DD'
                          )
                        }
                        readOnly={authUser?.user_type === 'super_admin'}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>Type</Label>
                      <Select
                        options={typeOptions}
                        onChange={handleTypeSelection}
                        value={selectedType}
                        isDisabled={authUser?.user_type === 'super_admin'}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>Status</Label>
                      <Select
                        options={statusOptions}
                        onChange={handleStatusSelection}
                        value={selectedStatus}
                        isDisabled={authUser?.user_type === 'staff'}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <Label>Remarks</Label>
                      <AvField
                        name="remarks"
                        placeholder="Enter Remarks"
                        type="textarea"
                        className="form-control"
                        defaultValue={attendanceInfo?.remarks}
                        readOnly={authUser?.user_type === 'staff'}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <ModalFooter>
                  <Button
                    disabled={attendanceUpdateRequestLoading}
                    type="button"
                    color="light"
                    onClick={closeModalHandler}
                  >
                    Close
                  </Button>
                  <Button type="submit" color="success">
                    {attendanceUpdateRequestLoading
                      ? 'Updating ...'
                      : 'Update Attendance'}
                  </Button>
                </ModalFooter>
              </AvForm>
            </React.Fragment>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(UpdateAttendanceModal);
